import React from "react";
import * as AV from "../AVCore/AVCore";
import { RootStateOrAny, useSelector } from "react-redux";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, Typography, ListItemIcon, ListItemText } from "@mui/material";
import EntityProfilePic from "../components/common/EntityProfilePic";

interface Props {
  value: any;
  label: string;
  options: any[];
  onChange: (event: any) => void;
  isDisabled?: boolean;
}

const AVDropdown = ({
  value,
  label,
  options,
  onChange,
  isDisabled = false,
}: Props) => {
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const selected = options?.find((x) => (x?.value ?? x?.id ?? x?.name) === value);

  return (
    <FormControl fullWidth>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>

      <Select
        labelId={`${label}-label`}
        value={value}
        label={label}
        onChange={onChange}
        disabled={isDisabled}
        renderValue={() => {
          if (selected?.labelSeason) {
            //return (
            //  <Box display="flex" alignItems="center">
            //    <Box ml={1}>
            //      <Typography fontWeight={600} fontSize="14px" lineHeight={1.2}>
            //        {selected.labelTeam}
            //      </Typography>
            //
            //      <Typography variant="caption" color="text.secondary">
            //        {selected.labelSeason}
            //      </Typography>
            //    </Box>
            //  </Box>
            //);
            return selected?.labelSeason || selected?.labelTeam;
          }

          return (
            selected?.loc ||
            selected?.title ||
            selected?.label ||
            selected?.value ||
            ""
          );
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 250,
            },
          },
        }}
      >
        {options?.map((option) =>
          option?.labelSeason ? (
            option?.value !== "others" ? (
              <MenuItem
                key={option?.value}
                value={option?.value}
                sx={{
                  py: 1.5,
                  alignItems: "flex-start",
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <EntityProfilePic
                    width={38}
                    height={38}
                    link={AV.AVEntity.getLink(
                      entityDataList?.find(
                        (x: AV.IAVEntity) => x?.id === option?.id,
                      ),
                    )}
                  />
                </ListItemIcon>

                <ListItemText
                  primary={
                    <Typography fontWeight={600} fontSize="15px">
                      {option?.labelTeam}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" color="text.secondary">
                      {option?.labelSeason}
                    </Typography>
                  }
                />
              </MenuItem>
            ) : (
              <MenuItem key={option?.value} value={option?.value}>
                {option?.labelTeam}
              </MenuItem>
            )
          ) : (
            <MenuItem
              key={option?.name || option?.id || option?.value}
              value={option?.name || option?.id || option?.value}
            >
              {option?.loc || option?.title || option?.label || option?.value}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};

export default AVDropdown;
